import React from 'react'

export default function HeaderSearchIcon() {
    return (
        <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M4.55718 8.91123C6.7418 8.91123 8.51279 7.14024 8.51279 4.95561C8.51279 2.77099 6.7418 1 4.55718 1C2.37255 1 0.601562 2.77099 0.601562 4.95561C0.601562 7.14024 2.37255 8.91123 4.55718 8.91123Z" stroke="#352D2E" strokeWidth="1.05483" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.0941 10.4935L7.35156 7.75098" stroke="#352D2E" strokeWidth="1.05483" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}
